export default function getEnvironment() {
  // Use Next.js environment variables for environment detection
  // NODE_ENV is automatically set by Next.js
  if (process.env.NODE_ENV === 'development') {
    return 'local';
  }
  
  // Check for custom environment variables
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' || process.env.VERCEL_ENV === 'production') {
    return 'production';
  }
  
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview' || process.env.VERCEL_ENV === 'preview') {
    return 'staging';
  }
  
  // Fallback to URL-based detection for client-side when env vars aren't available
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    switch (url.hostname) {
      case "test.floats.ai":
        return "staging";
      case "app.floats.ai":
        return "production";
      default:
        return "local";
    }
  }
  
  return 'local';
}
